<template>
  <b-modal
    :id="modalId"
    :ref="modalId"
    :title="title"
    :visible="visible"
    hide-footer
    size="xl"
    @hidden="$emit('close')"
  >
    <b-table
      hover
      :items="rows"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      show-empty
      bordered
    >
      <template #empty="">
        <h3 class="text-center">Không có dữ liệu!</h3>
      </template>
      <template #cell(index)="row">
        {{ row.item.index + 1 }}
      </template>
      <template #cell(stockSlipCode)="row">
        <a
          v-if="row.item.stockSlipCode"
          href="#"
          @click.prevent="openStockSlip(row.item.stockSlipId)"
        >
          {{ row.item.stockSlipCode }}
        </a>
      </template>
      <template #cell(billId)="row">
        <a
          v-if="row.item.billId"
          href="#"
          @click.prevent="openWarranty(row.item.billId)"
        >
          {{ row.item.billId }}
        </a>
      </template>
      <template #cell(totalAmount)="row">
        {{ convertPrice(row.item.totalAmount) }}
      </template>
      <template #cell(quantity)="row">
        {{ convertPrice(row.item.quantity) }}
      </template>
      <template #cell(originalPrice)="row">
        {{ convertPrice(row.item.originalPrice) }}
      </template>
      <template #cell(grossProfit)="row">
        {{ convertPrice(row.item.grossProfit) }}
      </template>
    </b-table>
    <b-row>
      <b-col fixed>
        <p class="mt-3 text-dark" style="font-weight: 500">
          Tổng số:
          {{ rows.length }}
        </p>
      </b-col>
      <b-pagination
        class="custom-pagination"
        v-show="rows.length > perPage"
        v-model="currentPage"
        :total-rows="rows.length"
        :per-page="perPage"
        align="right"
      />
    </b-row>
    <div class="d-flex justify-content-end mt-3">
      <b-button
        size="sm"
        class="mr-2"
        :disabled="!rows.length"
        variant="primary"
        v-if="hasExportExcel"
        @click="exportToExcel"
      >
        <i style="font-size: 1rem" class="fas fa-file-excel"></i>
        <strong>Xuất Excel</strong>
      </b-button>
      <b-button
        style="width: 80px"
        variant="secondary"
        size="sm"
        @click="$emit('close')"
      >
        <strong>Đóng</strong>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import xlsx from 'xlsx'
import { convertPrice, removeAccents } from '@/utils/common'

export default {
  name: 'ReplaceProductWarrantyReportModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'danh-sach-phieu-xuat-linh-kien',
    },
    rows: {
      type: Array,
      default: () => [],
    },
    modalId: {
      type: String,
      default: 'modal-stock-slip-by-employee',
    },
    hasExportExcel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      fields: [
        { key: 'index', label: 'STT', thStyle: { width: '5%' }, tdClass: 'text-center' },
        { key: 'stockSlipCode', label: 'Mã phiếu kho', tdClass: 'text-left' },
        { key: 'billId', label: 'ID BH', tdClass: 'text-left' },
        { key: 'productName', label: 'Linh kiện/Dịch vụ', tdClass: 'text-left' },
        { key: 'quantity', label: 'Số lượng', tdClass: 'text-right' },
        { key: 'exportReasonName', label: 'Lý do', tdClass: 'text-left' },
        { key: 'totalAmount', label: 'Tổng tiền', tdClass: 'text-right' },
        { key: 'originalPrice', label: 'Giá gốc', tdClass: 'text-right' },
        { key: 'grossProfit', label: 'Lãi gộp', tdClass: 'text-right' },
      ],
    }
  },
  watch: {
    visible(v) {
      if (v) this.currentPage = 1
    },
  },
  methods: {
    convertPrice,
    openStockSlip(id) {
      if (!id) return
      const route = this.$router.resolve({ name: 'edit-inventory-dispatch', query: { id } })
      window.open(route.href, '_blank')
    },
    openWarranty(id) {
      if (!id) return
      const route = this.$router.resolve({ name: 'warranty-dispatch-info', query: { id } })
      window.open(route.href, '_blank')
    },
    exportToExcel() {
      if (!this.rows.length) return
      const exportData = this.rows.map((item) => ({
        STT: item.index + 1,
        'Linh kiện/Dịch vụ': item.productName || '',
        'Số lượng': item.quantity || '',
        'Mã phiếu': item.stockSlipCode || '',
        'Lý do': item.exportReasonName || '',
        'Người xuất': item.createdByName || '',
        'Tổng tiền': item.totalAmount ?? '',
        'Giá gốc': item.originalPrice ?? '',
        'Lãi gộp': item.grossProfit ?? '',
      }))
      const wb = xlsx.utils.book_new()
      const ws = xlsx.utils.json_to_sheet(exportData)
      xlsx.utils.book_append_sheet(wb, ws, 'Danh sách phiếu xuất')
      const dateStr = new Date().toISOString().slice(0, 10)
      const createdByName = this.rows[0].createdByName || ''
      const fileNameBase = removeAccents(`phieu-xuat-lkdv-${createdByName}-${dateStr}`)
      xlsx.writeFile(wb, `${fileNameBase}-${dateStr}.xlsx`)
    },
  },
}
</script>
